<script>
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import formtreeselectmulti from "@/router/views/formcomponet/formtreeselectmulti.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlpplanrapor from "@/models/tlpplanrapor";
import useVuelidate from "@vuelidate/core";  
export default {
  mixins: [Api, Sabit, tlpplanrapor],
  props: ["Id", "AddEdit", "BaslangicTarih"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: {
        
      Planlanantalepids: [],
      Yapilantalepids: [] 

      },
      ModalOpen: false,
    };
  },
  components: {
    formtextarea,  formtreeselectmulti
  },
  watch: {

    Id() {
      this.FormData = this.Id;
      if (this.FormData) {
        this.ModalOpen = true
        if (this.AddEdit == "Add") {
          this.FormData = this.tlpplanraporData
          this.FormData.Tarih = this.formatDb(this.BaslangicTarih)
        }

      }
    },
    ModalOpen() {

      if (this.ModalOpen == false) {
        this.$emit("ModalOpen");
      }
    },
    
  },
  
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.AddEdit == "Add") {
          this.FormData.Personelid = this.TokenPersonelId
          this.Post("tlpplanrapor", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("tlpplanrapor", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },

    Get() { },
    Sil(Id) {
      this.Delete('tlpplanrapor', Id)
      this.ModalOpen = false
      this.$emit("ModalOpen");
    }
  },
};
</script>
<style scoped>
.tarih-box {
  display: inline-block;
  padding: 14px 30px;
  font-size: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #4e73df, #224abe);
  color: #fff;
  border-radius: 40px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}
</style>
<template>
  <b-modal
    v-model="ModalOpen"
    id="tlpplanrapor"
    size="xl"
    :title="AddEdit == 'Edit' ? 'Kayıt Düzenle' : 'Yeni Kayıt Ekle'"
    title-class="font-18 font-weight-bold"
    hide-footer
  >
    <Form @submit.prevent="onSubmit" v-if="FormData">

<!-- Tarih -->
<div class="text-center mb-4">
  <div class="tarih-box">
    📅 {{ FormData.Tarih }}
  </div>
</div>


      <!-- Talepler -->
      <b-row>
        <b-col md="6">
          <b-card class="mb-3 shadow-sm">
            <h6 class="text-muted mb-2">📌 Planlama</h6>

            <formtreeselectmulti
              :FormDataType="FormDataType.Planlanantalepids"
              :Value="FormData.Planlanantalepids"
              :v="v$.FormData.Planlanantalepids"
              @input="FormData.Planlanantalepids = $event"
            />



            <formtextarea
              class="small-textarea"
              :FormDataType="FormDataType.Plan"
              :Value="FormData.Plan"
              :v="v$.FormData.Plan"
              @input="FormData.Plan = $event.target.value"
            />
          </b-card>
        </b-col>

        <b-col md="6">
          <b-card class="mb-3 shadow-sm">
            <h6 class="text-muted mb-2">✅ Rapor</h6>

            <formtreeselectmulti
              :FormDataType="FormDataType.Yapilantalepids"
              :Value="FormData.Yapilantalepids"
              :v="v$.FormData.Yapilantalepids"
              @input="FormData.Yapilantalepids = $event"
            />
              <formtextarea
              class="small-textarea"
              :FormDataType="FormDataType.Rapor"
              :Value="FormData.Rapor"
              :v="v$.FormData.Rapor"
              @input="FormData.Rapor = $event.target.value"
            />
          </b-card>
        </b-col>
      </b-row>

 

      <!-- Butonlar -->
      <div class="d-flex justify-content-between align-items-center mt-4">
        <button
          v-if="AddEdit == 'Edit'"
          class="btn btn-sm btn-outline-danger"
          type="button"
          @click="Sil(FormData.Id)"
        >
          🗑 Sil
        </button>

        <button class="btn btn-sm btn-primary px-4" type="submit">
            Kaydet
        </button>
      </div>

    </Form>
  </b-modal>
</template>


